import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class TransitProgramDriver extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  active: boolean;

  @autoserialize
  preferred: boolean;

  @autoserialize
  approved: boolean;

  @autoserialize
  enabled: boolean;

  @autoserializeAs(Date)
  approvedDate: Date;

  @autoserialize
  interested: boolean;

  @autoserializeAs(Date)
  interestedDate: Date;

  @autoserializeAs(Date)
  firstEnabledDate: Date;

  constructor() {
    super();
    this.active = true;
  }

  /**** Serialization ****/

  static OnSerialized(instance: TransitProgramDriver, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.approvedDate)) {
      json.firstApprovedDate = DateUtil.serializeDate(instance.approvedDate);
    }

    if (!isNullOrUndefined(instance.interestedDate)) {
      json.interestedDate = DateUtil.serializeDate(instance.interestedDate);
    }
  }

  static OnDeserialized(instance: TransitProgramDriver, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['approvedDate'])) {
      instance.approvedDate = DateUtil.deserializeDate(json['approvedDate']);
    }

    if (!isNullOrUndefined(json['interestedDate'])) {
      instance.interestedDate = DateUtil.deserializeDate(json['interestedDate']);
    }
  }
}
